import Skeleton from 'react-loading-skeleton';
import styled, { css } from 'styled-components';

export const SkeletonList = styled(Skeleton)(
    ({ theme: { boxShadow, radius } }) => css`
        border-radius: ${radius[4]}px;
        box-shadow: ${boxShadow.small};
        margin-bottom: 4px;
    `,
);
